import React from 'react'

type CheckIconProps = {
  color?: string
}

const CheckIcon = ({ color }: CheckIconProps) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM4.65686 12.6569L6.77818 10.5355L9.77818 13.5355L17.6569 5.65686L19.7782 7.77818L9.77818 17.7782L4.65686 12.6569Z'
        fill={color || '#0C6CF2'}
      />
    </svg>
  )
}

export default CheckIcon
